import type { RootState } from '@/store/store'

export const selectIsNavBarCollapsed = (state: RootState) => state.ui.collapsed

export const selectIsDarkMode = (state: RootState) => state.ui.isDarkMode
